import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";

import { LeadModalProvider } from "@/context/LeadModalContext";
import LeadCaptureModal from "@/components/LeadCaptureModal";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

import Home from "@/pages/Home";
import Pricing from "@/pages/Pricing";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import AdminStudio from "@/pages/AdminStudio";

function ScrollHandler() {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (hash) {
            const el = document.querySelector(hash);
            if (el) {
                el.scrollIntoView({ behavior: "smooth", block: "start" });
                return;
            }
        }
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname, hash]);
    return null;
}

function AppShell() {
    return (
        <>
            <Navbar />
            <ScrollHandler />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/admin" element={<AdminStudio />} />
                <Route path="*" element={<Home />} />
            </Routes>
            <Footer />
            <LeadCaptureModal />
            <Toaster
                position="bottom-right"
                theme="dark"
                toastOptions={{
                    style: {
                        background: "#0a1325",
                        border: "1px solid rgba(0, 240, 255, 0.3)",
                        color: "#fff",
                    },
                }}
            />
        </>
    );
}

function App() {
    return (
        <div className="App">
            <HelmetProvider>
                <BrowserRouter>
                    <LeadModalProvider>
                        <AppShell />
                    </LeadModalProvider>
                </BrowserRouter>
            </HelmetProvider>
        </div>
    );
}

export default App;
